var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center py-5"},[_c('b-spinner',{staticClass:"mr-1",attrs:{"variant":"primary"}}),_c('span',[_vm._v("Loading dashboard...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }